import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { useOrderBumps } from '../hooks/useOrderBumps';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const {
    goToCheckout
  } = useOrderBumps();
  useEffect(() => {
    const handleScroll = () => {
      const scrollPercent = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
      setIsVisible(scrollPercent > 0.4);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-761">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-0 left-0 right-0 p-4 bg-cream/95 backdrop-blur-sm border-t border-brown/10 z-50 md:hidden shadow-[0_-4px_20px_rgba(0,0,0,0.05)]" data-id="element-762">
          <CTAButton text="I'm Ready for Relief" onClick={goToCheckout} fullWidth data-id="element-763" />
        </motion.div>}
    </AnimatePresence>;
}